'use strict'
import { axios, getErrorMessage } from '../helpers/axioshelper'

export default {
  getAllReports() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/expertreport/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getReport(reportId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/expertreport/${reportId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getReportDetails(reportId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/customerexpertreport/${reportId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addReport(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/expertreport/`, data)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateReport(report) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/expertreport/${report.id}`, report)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteReport(reportId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/expertreport/${reportId}`)
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteTranslation(reportId, translationId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/expertreport/${reportId}/translations/${translationId}`)
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateTranslatedName(reportId, translation) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/expertreport/${reportId}/translations/${translation.translationId}/name`, translation)
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}
